import React, { createContext, useState, useEffect, useContext } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import exampleBackground2 from "../../assets/exBackground2.jpg";
import { loadStandardProfileBackgrounds, getStandardProfileBackgroundValue } from '../../services/StandardProfileBackgroundService';

const BackgroundContext = createContext();


export const useBackground = () => useContext(BackgroundContext);

export const BackgroundProvider = ({ children, pageOwner }) => {
    const [backgroundImage, setBackgroundImage] = useState(null);

    useEffect(() => {
        const fetchBackgroundImage = async () => {
            if (pageOwner && pageOwner.email) {
                const db = getFirestore();
                const userDocRef = doc(db, "users", pageOwner.email);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    const data = userDoc.data();
                    if (data.gradCardBackgroundImage) {
                        setBackgroundImage(data.gradCardBackgroundImage);
                        return;
                    }

                    const standardBackgrounds = await loadStandardProfileBackgrounds(db);
                    setBackgroundImage(getStandardProfileBackgroundValue(standardBackgrounds[0]) || exampleBackground2);
                }
            }
        };

        fetchBackgroundImage();
    }, [pageOwner]);

    return (
        <BackgroundContext.Provider value={{ backgroundImage, setBackgroundImage }}>
            {children}
        </BackgroundContext.Provider>
    );
};
